import * as React from 'react'
import { GridColumnVisibilityModel, GridDensity } from '@mui/x-data-grid-pro'
import { ActionMenu } from '@user/components/Settings/Roles/ActionMenu'
import { Role } from '@user/store/roles/typings'

interface Props {
  handleEditClick?: (webhook: Role) => void
  handleDeleteRequest?: (webhookId: number) => void
  densityMode?: GridDensity
}

export const rolesListColumns = ({
  handleEditClick,
  handleDeleteRequest,
  densityMode,
}: Props) => {
  return [
    {
      width: 120,
      type: 'actions',
      field: 'actions',
      headerName: 'Actions',
      renderHeader: () => null,
      sortable: false,
      resizable: false,
      filterable: false,
      disableReorder: true,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        handleEditClick &&
        handleDeleteRequest && (
          <ActionMenu
            role={row}
            handleEditClick={handleEditClick}
            handleDeleteRequest={handleDeleteRequest}
            densityMode={densityMode}
          />
        ),
    },
    {
      field: 'roleName',
      headerName: 'Role Name',
      valueGetter: ({ row }) => row.name,
    },
    {
      field: 'product',
      headerName: 'Product',
      valueGetter: ({ row }) =>
        row.name === 'Admin' ? 'WorkWave Marketing' : 'Sales Center',
    },
    {
      field: 'createdTime',
      headerName: 'Date Created',
      type: 'date',
    },
  ]
}

export const defaultColVis = rolesListColumns(
  {},
).reduce<GridColumnVisibilityModel>((acc, { field }) => {
  if (acc[field] === undefined) {
    return { ...acc, [field]: true }
  } else return acc
}, {})

export const defaultColumns = rolesListColumns({}).map((c) => c.field)
